import { hasRule, espaceEmployeurRules as rules } from "@/utils/rulesHelper";

function buildMenu() {
  let children = []

  children.push({ name: 'Accueil', url: '/espace-employeur/accueil', icon: 'icon-home' })

  if (hasRule(rules.CAN_MANAGE_AFFECTATION_GRILLE)) {
    children.push({ name: 'Affectation grille', url: '/espace-employeur/affectation-sm', icon: 'fa fa-list-alt' })
  }

  if (hasRule(rules.CAN_MANAGE_INSCRIPTION)) {
    children.push({ name: 'Codes Inscription', url: '/espace-employeur/inscription-cev', icon: 'fa fa-user-plus' })
  }

  if (hasRule(rules.CAN_CHANGE_ADMINISTRATEUR_EMAIL)) {
    children.push({ name: 'Chgt Administrateur', url: '/espace-employeur/edit/admin', icon: 'fa fa-shield' })
  }

  if (hasRule(rules.CAN_CHANGE_RAISON_SOCIALE)) {
    children.push({ name: 'Chgt Raison sociale', url: '/espace-employeur/edit/siret', icon: 'fa fa-briefcase' })
  }

  return children
}

let menu = {
  items: buildMenu()
}
export default menu
